import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2, ShoppingCart, ArrowRight } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
export function AddedToCartModal() {
  const {
    isAddedModalOpen,
    closeAddedModal,
    lastAddedProduct,
    openCart
  } = useCartStore();
  if (!lastAddedProduct) return null;
  return <AnimatePresence data-id="element-10" data-mp="24mn0tmgmqzas">
      {isAddedModalOpen && <>
          <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 pointer-events-none" data-id="element-11" data-mp="1gzetkyzn5g64">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeAddedModal} className="fixed inset-0 bg-brand-primary/40 backdrop-blur-md pointer-events-auto" data-id="element-12" data-mp="1c1lpqclt8y90" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.4,
          ease: [0.23, 1, 0.32, 1]
        }} className="w-full max-w-md bg-brand-bg rounded-[2rem] shadow-premium overflow-hidden flex flex-col pointer-events-auto relative z-10 border border-white/50" data-id="element-13" data-mp="t8huwnwuwfct">
              <div className="flex items-center justify-between p-8 border-b border-brand-primary/10" data-id="element-14" data-mp="9txbxz0v3ccc">
                <div className="flex items-center gap-3 text-brand-accent" data-id="element-15" data-mp="ev4i5tncw3gw">
                  <CheckCircle2 className="w-6 h-6" data-id="element-16" data-mp="1landv5y95i05" />
                  <h2 className="text-xl font-serif font-medium text-brand-primary" data-id="element-17" data-mp="1lc86ur4x4svw">Додано в кошик</h2>
                </div>
                <button onClick={closeAddedModal} className="p-2 hover:bg-brand-surfaceAlt rounded-full transition-colors" data-id="element-18" data-mp="3mcd1m9xhtxtc">
                  <X className="w-5 h-5 text-brand-muted" data-id="element-19" data-mp="3icuhhgdhxqrk" />
                </button>
              </div>

              <div className="p-8" data-id="element-20" data-mp="32c3483qs0i">
                <div className="flex items-center gap-5 mb-10" data-id="element-21" data-mp="3ray7opzffbpp">
                  <img src={lastAddedProduct.img} alt={lastAddedProduct.title} className="w-20 h-20 object-cover rounded-xl border border-white shadow-subtle" data-id="element-22" data-mp="3r9n1ykmf7tvy" />
                  <div data-id="element-23" data-mp="3dbyfx9gmagpb">
                    <h3 className="font-serif font-medium text-brand-primary text-lg leading-tight mb-2" data-id="element-24" data-mp="3dcgisoxsbt67">
                      {lastAddedProduct.title}
                    </h3>
                    <p className="text-brand-muted font-light text-base" data-id="element-25" data-mp="2kum6eg1b5dpw">
                      {lastAddedProduct.price} грн
                    </p>
                  </div>
                </div>

                <div className="flex flex-col gap-4" data-id="element-26" data-mp="ve09w2qb6v18">
                  <button onClick={openCart} className="w-full py-4 bg-brand-accent hover:bg-brand-accentHover text-white rounded-full font-medium text-lg transition-all shadow-button flex items-center justify-center gap-3" data-id="element-27" data-mp="vc5s2xac3j1d">
                    <ShoppingCart className="w-5 h-5" data-id="element-28" data-mp="qff8hzzbm5b7" />
                    Оформити замовлення
                  </button>
                  <button onClick={closeAddedModal} className="w-full py-4 bg-brand-surfaceAlt hover:bg-brand-surface text-brand-primary rounded-full font-medium text-lg transition-colors flex items-center justify-center gap-3 border border-brand-primary/5" data-id="element-29" data-mp="1e2x3039yzhhv">
                    Продовжити покупки
                    <ArrowRight className="w-5 h-5" data-id="element-30" data-mp="3pthnzna23y4q" />
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}